import React, { useState, useEffect } from 'react';
import { FaStarOfLife } from 'react-icons/fa';
import { Container } from 'rsuite';
import ContainerInterno from '../../../components/ContainerInterno';
import { NotificationManager } from 'react-notifications';
import api from '../../../services/api';
import RModal from '../../../components/Rsuite/Modal';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { CustomButton } from '../../../components/CustomButton';
import { CustomInput } from '../../../components/CustomInput';
import { CustomMaskedInput } from '../../../components/CustomMaskedInput';
import { CustomSelectPicker } from '../../../components/CustomSelectPicker';

const EditarCadastrarEntregador = ({
  modal,
  close,
  IdEmpresa,
  entregador,
  setEntregadores,
}) => {
  const [id, setId] = useState('');
  const [nome, setNome] = useState('');
  const [cpf, setCpf] = useState('');
  const [email, setEmail] = useState('');
  const [celular, setCelular] = useState('');
  const [ativo, setAtivo] = useState('');
  const [placeholderChar, setPlaceholderChar] = React.useState('_');
  const { theme } = useCustomTheme();

  const options = [
    {
      name: 'Celular',
      mask: [
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
      placeholder: '(63) 33333-3333',
    },
    {
      name: 'CPF',
      mask: [
        /[/0-9]/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ],
      placeholder: '999.999.999-99',
    },
  ];

  const data = [
    { value: 1, label: 'Sim' },
    { value: 0, label: 'Não' },
  ];

  const editarEntregador = async () => {
    if (id && ativo !== null && nome && celular && IdEmpresa) {
      await api
        .patch(`entregador/alterar/${id}`, {
          IdEmpresa,
          Nome: nome,
          Cpf: cpf,
          Email: email,
          Celular: celular,
          Id: id,
          Ativo: ativo,
        })
        .then((res) => {
          NotificationManager.info('Entregador alterado', 'Informação');
          setEntregadores((state) =>
            state.map((e) => {
              if (e.Id !== res.data.Id) {
                return e;
              }
              e = res.data;
              return e;
            }),
          );
          close();
        });
    } else {
      NotificationManager.error(
        'Preencha todos os campos obrigatórios',
        'Erro',
      );
    }
  };

  const cadastrarEntregador = async () => {
    if (nome && celular && IdEmpresa) {
      try {
        const res = await api.post('entregador/criar', {
          IdEmpresa: IdEmpresa,
          Nome: nome,
          Cpf: cpf,
          Email: email,
          Celular: celular,
        });

        NotificationManager.success('Entregador cadastrado', 'Sucesso');
        setEntregadores((state) => [...state, res.data]);
        close();
      } catch (error) {
        console.log({ error });
        if (error.response?.data?.message === 'Login exists') {
          return NotificationManager.error('Login já existe');
        }

        NotificationManager.error('Não foi possivel cadastrar');
      }
    } else {
      NotificationManager.error(
        'Preencha todos os campos obrigatórios',
        'Erro',
      );
    }
  };

  const abrirDados = (entregador) => {
    setId(entregador.Id);
    setNome(entregador.Nome);
    setCpf(entregador.Cpf);
    setEmail(entregador.Email);
    setCelular(entregador.Celular);
    setAtivo(entregador.Ativo);
  };

  useEffect(() => {
    if (entregador) {
      abrirDados(entregador);
    }
  }, [modal, entregador]);

  return (
    <RModal
      open={modal}
      onClose={close}
      title={entregador ? `Editar Entregador` : 'Cadastrar Entregador'}
      footer={
        <>
          <CustomButton
            onClick={entregador ? editarEntregador : cadastrarEntregador}
            appearance="primary"
          >
            {entregador ? 'Alterar' : 'Cadastrar'}
          </CustomButton>
          <CustomButton onClick={close} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <form>
        <Container>
          <ContainerInterno>
            <label htmlFor="nome">
              <b style={{ color: theme.colors.textSecondary }}>
                Nome <FaStarOfLife size={8} color="#FF0000" />
              </b>
            </label>
            <CustomInput type="text" value={nome} onChange={setNome} />
          </ContainerInterno>

          <ContainerInterno>
            <label htmlFor="nome" style={{ marginTop: 10 }}>
              <b style={{ color: theme.colors.textSecondary }}>CPF</b>
            </label>
            <CustomMaskedInput
              value={cpf}
              mask={options[1].mask}
              guide={false}
              showMask={true}
              keepCharPositions={false}
              placeholder={options[1].placeholder}
              placeholderChar={placeholderChar}
              style={{ width: 300 }}
              onChange={setCpf}
            />
          </ContainerInterno>
        </Container>
        <Container>
          <ContainerInterno>
            <label htmlFor="Celular" style={{ marginTop: 10 }}>
              <b style={{ color: theme.colors.textSecondary }}>
                Celular <FaStarOfLife size={8} color="#FF0000" />
              </b>
            </label>
            <CustomMaskedInput
              value={celular}
              mask={options[0].mask}
              guide={false}
              showMask={true}
              keepCharPositions={false}
              placeholder={options[0].placeholder}
              placeholderChar={placeholderChar}
              style={{ width: 300 }}
              onChange={setCelular}
            />
          </ContainerInterno>

          <ContainerInterno>
            <label htmlFor="Celular" style={{ marginTop: 10 }}>
              <b style={{ color: theme.colors.textSecondary }}>E-mail</b>
            </label>
            <CustomInput
              type="email"
              style={{ width: 300 }}
              value={email}
              onChange={setEmail}
            />
          </ContainerInterno>
        </Container>

        {entregador && (
          <Container>
            <ContainerInterno>
              <label htmlFor="ativo" style={{ marginTop: 10 }}>
                <b style={{ color: theme.colors.textSecondary }}>Ativo</b>
              </label>
              <CustomSelectPicker
                data={data}
                style={{ width: 300 }}
                onChange={setAtivo}
                defaultValue={entregador.Ativo ? 1 : 0}
                searchable={false}
              />
            </ContainerInterno>
          </Container>
        )}
      </form>
    </RModal>
  );
};

export default EditarCadastrarEntregador;
